@if ($data().items.length === 0) {
    <cm-full-page-feedback text="No tasks to show"></cm-full-page-feedback>
} @else {
    <div class="cm-job-tasks-table">
        <cm-table-cell class="cm-first-column" [header]="true"> ID </cm-table-cell>
        <cm-table-cell [centered]="true" [header]="true"> State </cm-table-cell>
        <cm-table-cell [header]="true"> Name </cm-table-cell>
        <cm-table-cell [header]="true"> Message </cm-table-cell>
        <cm-table-cell [header]="true"> Resource cascade </cm-table-cell>
        @for (row of $data().items; track row.trackId) {
            <div class="cm-ruler"></div>
            <div class="cm-table-row" (click)="clickItem.emit(row?.data ?? undefined)">
                <cm-table-cell [item]="row">
                    <span class="cm-id-cell">
                        <span class="cm-id cm-first-column">{{ row.data?.legacyId }}</span>
                        <cm-copy-id-button [value]="row.data?.legacyId"></cm-copy-id-button>
                    </span>
                </cm-table-cell>
                <cm-table-cell [item]="row" [centered]="true">
                    <cm-job-task-thumbnail
                        [jobTask]="row.data"
                        [progress]="row.data?.state === JobTaskState.Running || row.data?.state === JobTaskState.Runnable ? (row.data?.progress ?? null) : null"
                    ></cm-job-task-thumbnail>
                </cm-table-cell>
                <cm-table-cell [item]="row">
                    <cm-overflowable-text [class.cm-name-fallback]="!row.data?.name">
                        {{ row.data?.name ?? row.data?.taskType ?? "-" }}
                    </cm-overflowable-text>
                </cm-table-cell>
                <cm-table-cell [item]="row">
                    <cm-overflowable-text>
                        {{ row.data?.message }}
                    </cm-overflowable-text>
                </cm-table-cell>
                <cm-table-cell [item]="row">
                    <cm-job-task-cascade [cascade]="row.data?.cascade ?? []" [pinned]="!!row.data?.resourceGroupPin"></cm-job-task-cascade>
                </cm-table-cell>
            </div>
        }
    </div>
}
